import React, { createContext, useContext, useState } from 'react';

interface ModalContextProps {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
}

interface ModalContextType {
  accountUnderReviewModal: ModalContextProps
}

const ModalContext = createContext<ModalContextType>({
  accountUnderReviewModal: {
    isModalOpen: false,
    openModal: () => {
      //
    },
    closeModal: () => {
      //
    },
    toggleModal: () => {
      //
    },
  }
});

export const useAccountUnderReviewModal = () => useContext(ModalContext);

export const ModalProvider: React.FC = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <ModalContext.Provider value={{ accountUnderReviewModal: { isModalOpen, openModal, closeModal, toggleModal } }}>
      {children}
    </ModalContext.Provider>
  );
};